import React, { Component } from "react";
import { IconContext } from "react-icons";
import { ImGithub } from "react-icons/im";
import { FaFacebookF } from "react-icons/fa";
import { FiTwitter } from "react-icons/fi";
import { GrLinkedinOption } from "react-icons/gr";
import { HiChevronDoubleLeft } from "react-icons/hi";
import { IoMdPlay } from "react-icons/io";
import ellipse_1 from "../assets/images/Ellipse_1.png";
import ellipse_2 from "../assets/images/Ellipse_2.png";
import ellipse_3 from "../assets/images/Ellipse_3.png";
import ellipse_4 from "../assets/images/react.png";
import ellipse_5 from "../assets/images/nodejs.png";
import ellipse_6 from "../assets/images/jest.png";
import ellipse_7 from "../assets/images/scss.svg";
import ellipse_8 from "../assets/images/bootstrap.png";
import ellipse_9 from "../assets/images/redux.png";
import ellipse_10 from "../assets/images/mongodb.png";
import ellipse_11 from "../assets/images/postgresql.png";
import ellipse_12 from "../assets/images/docker.png";
import ellipse_13 from "../assets/images/typescript.png";
import ellipse_14 from "../assets/images/passport.png";
import ellipse_15 from "../assets/images/tailwind.png";
import ellipse_17 from "../assets/images/ruby.png";
import ellipse_18 from "../assets/images/rails.png";
import ellipse_19 from "../assets/images/python.png";
import ellipse_20 from "../assets/images/nestjs-icon.svg";
import ellipse_21 from "../assets/images/nextjs.svg";
import ellipse_22 from "../assets/images/Pinecone.svg";
import ellipse_23 from "../assets/images/auth0.svg";
import ellipse_24 from "../assets/images/bash.svg";
import ellipse_25 from "../assets/images/aws.svg";
import ellipse_26 from "../assets/images/firebase.svg";
import ellipse_27 from "../assets/images/prisma.svg";
import ellipse_28 from "../assets/images/nginx.svg";
import ellipse_29 from "../assets/images/vue.svg";
import ellipse_30 from "../assets/images/vuex.svg";
import about from "../assets/images/about.jpg";
import debug from "../assets/images/debugger.svg";
import deliver from "../assets/images/deliver.svg";
import coder from "../assets/images/coder.svg";
import AOS from "aos";
import "aos/dist/aos.css";

const languages = [
  { id: 1, title: "JavaScript", image: ellipse_1 },
  { id: 2, title: "TypeScript", image: ellipse_13 },
  { id: 3, title: "Ruby", image: ellipse_17 },
  { id: 4, title: "Python", image: ellipse_19 },
  { id: 5, title: "Bash", image: ellipse_24 },
  { id: 6, title: "Html", image: ellipse_2 },
  { id: 7, title: "Css", image: ellipse_3 },
];

const frameWorksLibraries = [
  { id: 1, title: "Nest", image: ellipse_20 },
  { id: 2, title: "Express", image: ellipse_5 },
  { id: 3, title: "Rails", image: ellipse_18 },
  { id: 4, title: "Passport", image: ellipse_14 },
  { id: 5, title: "Nextjs", image: ellipse_21 },
  { id: 6, title: "React", image: ellipse_4 },
  { id: 7, title: "Vue", image: ellipse_29 },
  { id: 8, title: "Redux", image: ellipse_9 },
  { id: 9, title: "Vuex", image: ellipse_30 },
  { id: 10, title: "Jest", image: ellipse_6 },
  { id: 11, title: "scss", image: ellipse_7 },
  { id: 12, title: "Bootstrap", image: ellipse_8 },
  { id: 13, title: "Tailwind", image: ellipse_15 },
];
const databasesAndTools = [
  { id: 1, title: "Postgresql", image: ellipse_11 },
  { id: 2, title: "MongoDB", image: ellipse_10 },
  { id: 3, title: "PineConeDB", image: ellipse_22 },
  { id: 4, title: "FireBase", image: ellipse_26 },
  { id: 5, title: "AWS", image: ellipse_25 },
  { id: 6, title: "Auth0", image: ellipse_23 },
  { id: 7, title: "Prisma", image: ellipse_27 },
  { id: 8, title: "Ngnix", image: ellipse_28 },
  { id: 9, title: "Docker", image: ellipse_12 },
];

class About extends Component {
  state = {
    isLangOpen: false,
    isFramOpen: false,
  };

  componentDidMount() {
    AOS.init();
  }

  render() {
    const { onClick } = this.props;
    return (
      <section id="about" title="about" className="about">
        <div className="about-me-main-section">
          <h2 data-aos="fade-down-right" className="title">
            About me<span>.</span>
          </h2>
          <div className="main-about-wrapper-one">
            <div className="about-left-wrapper">
              <p data-aos="zoom-in-right" className="about-me-details">
                A polyglot Staff Software Engineer with 8+ years of experience
                spanning fintech, AI, and distributed systems across five
                continents. I’ve architected payment infrastructure serving 10M+
                users at Ivy(Augustus), Cajeropay, driven AI agent reliability at Layla.ai, and
                served as Tech Lead for global employment infrastructure at
                Oyster. Currently re-architecting enterprise payment systems at
                Cajeropay using Java, jOOQ, and Flyway.
                <br></br>
                My path began with telecom automation at Airtel in the DRC,
                evolved through full-stack product work in Rwanda and Honduras,
                and has grown into staff-level engineering and technical
                leadership across Amsterdam, Berlin, and Lithuania.
                <br></br>
                I hold an M.S. in Computer Science from Tulane University and a
                B.S. in Electronics and Telecommunications from the University
                of Kigali.
                <br></br>
                I thrive at the intersection of deep technical work and
                cross-functional leadership, from SWIFT payment integrations to
                LLM-powered flight ranking systems,  driven by building systems
                that are not just scalable, but meaningful.
              </p>

              <a
                data-aos="fade-right"
                data-aos-easing="ease-in-sine"
                href="https://www.linkedin.com/in/nganulo-rushanika-mo%C3%AFse-626139197/"
                className="about-connect"
              >
                <span>Let's connect</span>
                <span>
                  <IconContext.Provider
                    value={{ className: "about-connect-icon" }}
                  >
                    <HiChevronDoubleLeft />
                  </IconContext.Provider>
                </span>
              </a>
              <ul className="about-social-icon-list">
                <li
                  data-aos="fade-up-right"
                  data-aos-duration="1000"
                  className="social-media-link"
                >
                  <a href="https://www.facebook.com/moiseMrnrushanika">
                    <IconContext.Provider value={{ className: "about-icon" }}>
                      <FaFacebookF />
                    </IconContext.Provider>
                  </a>
                </li>
                <li
                  data-aos="fade-up-right"
                  data-aos-duration="4000"
                  className="social-media-link"
                >
                  <a href="https://github.com/moise10r">
                    <IconContext.Provider value={{ className: "about-icon" }}>
                      <ImGithub />
                    </IconContext.Provider>
                  </a>
                </li>
                <li
                  data-aos="fade-up-right"
                  data-aos-duration="7000"
                  className="social-media-link"
                >
                  <a href="#2">
                    <IconContext.Provider value={{ className: "about-icon" }}>
                      <FiTwitter />
                    </IconContext.Provider>
                  </a>
                </li>
                <li
                  data-aos="fade-up-right"
                  data-aos-duration="10000"
                  className="social-media-link"
                >
                  <a href="#2">
                    <IconContext.Provider value={{ className: "about-icon" }}>
                      <GrLinkedinOption />
                    </IconContext.Provider>
                  </a>
                </li>
              </ul>
            </div>
            <ul className="about-rigth-wrapper">
              <li className="languages-list">
                <h3 className="language-header">
                  <span data-aos="zoom-in" className="skill-title">
                    Languages
                  </span>
                </h3>
                <div className="about-rigth-list-wrapper ">
                  <ul className="languages-list-container">
                    {languages.map(({ image, id, title }, index) => (
                      <li
                        data-aos="flip-left"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration="10000"
                        key={id}
                        className="language-link fram"
                      >
                        <div className="img-wrapper">
                          <img src={image} alt="langueage" />
                        </div>
                        <span>{title}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
              <li className="languages-list">
                <h3 className="language-header">
                  <span data-aos="zoom-in" className="skill-title">
                    Frameworks & <strong className="under">Libraries</strong>
                  </span>
                </h3>
                <div className="about-rigth-list-wrapvper ">
                  <ul className="languages-list-container">
                    {frameWorksLibraries.map(({ image, id, title }, index) => (
                      <li
                        data-aos="flip-left"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration="10000"
                        key={id}
                        className="language-link"
                      >
                        <div className="img-wrapper">
                          <img src={image} alt="langueage" />
                        </div>
                        <span>{title}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
              <li className="languages-list">
                <h3 className="language-header">
                  <span data-aos="zoom-in" className="skill-title">
                    Databases & <strong className="under">Tools</strong>
                  </span>
                </h3>
                <div className="about-rigth-list-wrapvper ">
                  <ul className="languages-list-container">
                    {databasesAndTools.map(({ image, id, title }, index) => (
                      <li
                        data-aos="flip-left"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration="10000"
                        key={id}
                        className="language-link"
                      >
                        <div className="img-wrapper">
                          <img src={image} alt="langueage" />
                        </div>
                        <span>{title}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <div className="main-about-wrapper-two">
            <div className="about-left-main-container">
              <div data-aos="fade-right" className="experience-year">
                <span>8+</span>
                <span className="dot"></span>
              </div>
              <div className="year-paragraph">
                <div className="left"></div>
                <div data-aos="fade-up-right" className="right">
                  <span>Years</span>
                  <span>Experience</span>
                  <span>Working</span>
                </div>
              </div>
            </div>
            <div className="about-right-main-container">
              <h2 data-aos="fade-down-left" className="great-experience">
                Moïse is not just a dev
              </h2>
              <p data-aos="zoom-in-up" className="detail">
                From automating telecom systems at Airtel in Goma to building
                payment infrastructure at Ivy(Augustus) serving 10M+ users; from
                architecting AI-driven recruitment at Vaurse in Dubai to
                improving LLM agent stability at Layla.ai in Berlin,  Moïse's
                journey spans five continents, a dozen tech stacks, and roles
                from Network Engineer to Staff Software Engineer and Tech Lead.
                He brings first-principles thinking, polyglot adaptability, and
                a bias for impact. ...He also rarely speaks in third person
                (promise).
              </p>

              <div className="progrees-container">
                <div
                  data-aos="zoom-out-left"
                  data-aos-duration="10000"
                  className="progress"
                >
                  <div className="progress-container">
                    <span>Deliverer</span>
                  </div>
                  <span
                    style={{
                      width: "80px",
                      height: "80px",
                    }}
                  >
                    <img
                      src={deliver}
                      alt=""
                      srcSet=""
                      style={{
                        maxWidth: "100%",
                      }}
                    />
                  </span>
                  <span className="detail">
                    Tech Lead at Vaurse, driving cross-functional initiatives
                    across CIP, CCT, and Hire teams. Designed and led SWIFT
                    payment flows, diversified revenue streams, and made
                    architectural decisions across global employment
                    infrastructure serving customers in 180+ countries.
                  </span>
                </div>
                <div
                  data-aos="zoom-out-left"
                  data-aos-duration="30000"
                  className="progress"
                >
                  <div className="progress-container">
                    <span>Debugger</span>
                  </div>
                  <span
                    style={{
                      width: "80px",
                      height: "80px",
                    }}
                  >
                    <img
                      src={debug}
                      alt=""
                      srcSet=""
                      style={{
                        maxWidth: "100%",
                      }}
                    />
                  </span>
                  <span className="detail">
                    Reduced LLM hallucinations and improved AI agent stability
                    in production at Layla.ai. Automated issue detection at
                    Airtel, cutting MTTR and boosting customer satisfaction by
                    15%. Deep problem-solving instincts sharpened across
                    fintech, AI, and telecom systems over 8+ years.
                  </span>
                </div>
                <div
                  data-aos="zoom-out-left"
                  data-aos-duration="20000"
                  className="progress"
                >
                  <div className="progress-container">
                    <span>Developer</span>
                  </div>
                  <span
                    style={{
                      width: "80px",
                      height: "80px",
                    }}
                  >
                    <img
                      src={coder}
                      alt=""
                      srcSet=""
                      style={{
                        maxWidth: "100%",
                      }}
                    />
                  </span>
                  <span className="detail">
                    Built and maintained payment systems serving 10M+ users at
                    Ivy(Augustus), SWIFT, Faster Payments, iDEAL, Alipay, Open
                    Banking, and crypto infrastructure. Grew monthly active users
                    by 100% at Labvanced after a mobile/desktop launch. M.S. in
                    Computer Science, Tulane University.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="short-video-section">
          <div className="short-video-container">
            <div data-aos="zoom-in" className="about-img-wrapper">
              <img src={about} alt="bg" />
            </div>
            <div className="play-container">
              <div onClick={() => onClick()} className="play">
                <IconContext.Provider value={{ className: "about-icon" }}>
                  <IoMdPlay />
                </IconContext.Provider>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
